/*
 * @Author: zhaozhenda zhaozhenda@myhexin.com
 * @Date: 2023-07-17 20:35:29
 * @LastEditors: zhaozhenda
 * @LastEditTime: 2024-08-27 12:00:07
 * @FilePath: \investment-festival\src\utils\jump.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { SAFE_TIME } from './const';
import { getCurrentEnvMode } from './tools';
type ParamsInterface = Record<string, string | number>;
// // 组装Url
export const assembleUrl = (url: string): string => window.location.href.replace(/[^/]+(?=\.html)/, url);

// 格式化链接
const formatUrl = (url: string, params?: ParamsInterface): string => {
  let data = url;
  if (params) {
    Object.keys(params).forEach((item: string) => {
      data = `${data}${data.includes('?') ? '&' : '?'}${item}=${params[item]}`;
    });
  }
  return data;
};

export const jumpUrl = (url: string): void => {
  setTimeout(() => {
    if (!window.getParaByName('debug')) {
      window.location.href = url;
    }
  }, SAFE_TIME);
};

export const jumpReplace = (url: string): void => {
  if (!window.getParaByName('debug')) {
    window.location.replace(url);
  }
};

// 跳转自带导航栏的页面
export const jumpWithNoNavClient = (url: string): void => {
  setTimeout(() => {
    if (!window.getParaByName('debug')) {
      if (window.getAppVersion()) {
        location.href = `${
          window.getPlatform() === 'iphone'
            ? `client://client.html?action=ymtz^webid=2305^url=${
              url
              }^showStatusBar=1^mode=new^StayHighForStatusBar=0`
            : `client.html?action=ymtz^webid=2804^fullscreen=1^url=${ url }^notitlebar=1^mode=new^showStatusBar=1`
        }`;
      } else {
        jumpUrl(url);
      }
    }
  }, SAFE_TIME);
};

// 跳转新webview
export const jumpWithClient = (url: string): void => {
  setTimeout(() => {
    if (!window.getParaByName('debug')) {
      if (window.getAppVersion()) {
        window.location.href = `client.html?action=ymtz^webid=2804^url=${url}^mode=new`;
      } else {
        jumpUrl(url);
      }
    }
  }, SAFE_TIME);
};

export const backComponent = () => {
  setTimeout(() => {
    const type = window.getPlatform() === 'iphone' ? 'component' : 'webpage';
    window.callNativeHandler('goback', { type }, () => {
      // callback
    });
  }, SAFE_TIME);
};

export const jumpToShop = () => {
  jumpWithNoNavClient(assembleUrl('shop'));
};

// 跳转规则
export const jumpToRule = (): void => {
  jumpWithClient('https://mams.10jqka.com.cn/new/server/html/56095.html');
};

export const jumpToXtz = id => {
  const url = `https://xtz${
    getCurrentEnvMode() === 'release' ? '' : '-test'
  }.10jqka.com.cn/webApp/introduction?courseId=${id}`;
  jumpWithClient(url);
};
